/**
 * Management accounting reports
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The ChartsDataNetProfit model module.
* @module model/ChartsDataNetProfit
* @version 1.0.0
*/
export default class ChartsDataNetProfit {
    /**
    * Constructs a new <code>ChartsDataNetProfit</code>.
    * @alias module:model/ChartsDataNetProfit
    * @class
    * @param revenue {Number} 
    */

    constructor(revenue) {
        

        
        

        this['revenue'] = revenue;

        
    }

    /**
    * Constructs a <code>ChartsDataNetProfit</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ChartsDataNetProfit} obj Optional instance to populate.
    * @return {module:model/ChartsDataNetProfit} The populated <code>ChartsDataNetProfit</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ChartsDataNetProfit();

            
            
            

            if (data.hasOwnProperty('revenue')) {
                obj['revenue'] = ApiClient.convertToType(data['revenue'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {Number} revenue
    */
    revenue = undefined;








}


